import React from 'react';
import inputStyle from './ITextInput.module.scss';

interface IProps {
    id: string;
    name: string;
    label: string;
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    onBlur?: (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    error?: boolean;
    helperText?: string | false;
    placeholder?: string;
    type?: string;
    multiline?: boolean;
    rows?: number;
    maxLength: number;
}

const ITextInput = (props: IProps) => {
    const {
        id,
        name,
        label,
        value,
        onChange,
        onBlur,
        error = false,
        helperText,
        placeholder,
        type = 'text',
        multiline = false,
        rows = 5,
        maxLength,
    } = props;

    const describedBy = error && helperText ? `${id}-error` : undefined;
    const fieldClasses = `${inputStyle.field} ${error ? inputStyle.fieldError : ''}`;

    return (
        <div className={inputStyle.container}>
            <label className={inputStyle.label} htmlFor={id}>
                {label}
            </label>

            {multiline ? (
                <textarea
                    id={id}
                    name={name}
                    className={`${fieldClasses} ${inputStyle.textarea}`}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    placeholder={placeholder}
                    rows={rows}
                    maxLength={maxLength}
                    aria-invalid={error}
                    aria-describedby={describedBy}
                />
            ) : (
                <input
                    id={id}
                    name={name}
                    className={fieldClasses}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    placeholder={placeholder}
                    type={type}
                    maxLength={maxLength}
                    aria-invalid={error}
                    aria-describedby={describedBy}
                />
            )}

            {error && helperText && (
                <span id={`${id}-error`} className={inputStyle.helper} role='alert'>
                    {helperText}
                </span>
            )}
        </div>
    );
};

export default ITextInput;
